

import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class FlashMessage extends Vue {
  @Prop()
  private messages!: any

  @Watch('messages')
  private watchMessage(newValue: string, oldValue: string): void {
    const self = this
    if (this.messages.error && this.messages.error.length) {
      this.$buefy.toast.open({
        message: this.messages.error.join('<br />'),
        type: 'is-danger',
        duration: 3000
      })
    }
    if (this.messages.warning && this.messages.warning.length) {
      this.$buefy.toast.open({
        message: this.messages.warning.join('<br />'),
        type: 'is-warning',
        duration: 3000
      })
    }
    if (this.messages.info && this.messages.info.length) {
      this.$buefy.toast.open({
        message: this.messages.info.join('<br />'),
        type: 'is-success',
        duration: 3000
      })
    }
  }
}
